<template>
    <v-container fluid>
        <v-card elevation="10">
            <v-card-title class="mb-5 yellow white--text">Order History</v-card-title>
                <v-card-text class="text-left flex">
                    <div>
                        <template>
                        <v-data-table
                            :headers="headers"
                            :items="orders"
                            :expanded.sync="expanded"
                            item-key="id"
                            show-expand
                            single-expand
                            fixed-header
                            disable-pagination
                            hide-default-footer
                            class="elevation-1"
                        >
                            <template v-slot:item.pickupSlot="{ item }">
                                {{formatDateTime(item.pickupSlot)}}
                            </template>
                            <template v-slot:item.submitDate="{ item }">
                                {{formatDateTime(item.submitDate)}}
                            </template>
                            <template v-slot:item.status="{ item }">
                                <v-chip
                                        :class="item.status"
                                        class="ma-2"
                                        text-color="white">
                                        {{item.status}}
                                </v-chip>
                            </template>
                            <template v-slot:item.total="{ item }">
                                <strong>{{formatCurrency(item.total)}}</strong>
                            </template>                         -->
                            <template v-slot:top></template>
                            <template v-slot:expanded-item="{ headers, item }">
                            <td :colspan="headers.length" class="pa-0 ma-0">
                                <v-simple-table
                                    dense
                                    fixed-header
                                >
                                    <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th class="text-right">Quantity</th>
                                        <th class="text-right">Price</th>
                                        <th class="text-right">Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <tr :key="item2.id" v-for="item2 in item.items">
                                            <td style="font-size:12px;">{{item2.name}}</td>
                                            <td style="font-size:12px;" class="text-right">{{item2.quantity}}</td>
                                            <td style="font-size:12px;" class="text-right">{{formatCurrency(item2.price)}}</td>
                                            <td style="font-size:12px;" class="text-right">{{formatCurrency(item2.total)}}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </td>
                            </template>
                        </v-data-table>
                        </template>
                    </div>
                </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import api from "../services/aggrega8-api";
    import moment from 'moment';

    class Product {
        id = 0
        name = ''
        quantity = 0
        price = 0
        total = 0
    }

    class Order {
        id = 0
        distributorName = ''
        pickupSlot = ''
        submitDate = ''
        status = ''
        total = 0
        items = []
    }

    export default {
        name: 'Orders',
        computed: {
            userDetails: function () {
                return this.$store.state.userDetails
            },
            loggedIn: function () {
                return this.$store.state.loggedIn
            },
            executing: function () {
                return this.$store.state.executing
            },
        },
        data: () => ({
            orders: [],
            expanded: [],
            headers: [
            { text: 'Order #', align: 'end', value: 'id' },
            { text: 'Distributor', align: 'start', value: 'distributorName' },
            { text: 'Pickup slot', align: 'end', value: 'pickupSlot' },
            { text: 'Submit Date', align: 'end', value: 'submitDate' },
            { text: 'Status', value: 'status' },
            { text: 'Total', align: 'end', value: 'total' },
            { text: '', value: 'data-table-expand' },
            ],
        }),
        created() {
            this.orderList()
        },
        methods: {
            orderList()
            {
                this.$store.dispatch("setExecuting", true)
                api.get("/orders?type=JUST_IN_TIME&max=0").then(
                    (result) => {
                        let orderPromises = [];
                        result.data.forEach(item => {
                            let order = new Order()
                            order.id = item.id
                            order.pickupSlot = item.pickupSlot.startingTime

                            orderPromises.push(
                                Promise.all([
                                    api.get("/orders/" + order.id + "?type=JUST_IN_TIME"),
                                    api.get("/orders/" + order.id + "/items?type=JUST_IN_TIME")
                                ]).then(([orderDetails, orderItems]) => {
                                    order.distributorName = orderDetails.data.distributor.name
                                    order.submitDate = orderDetails.data.submissionDt
                                    order.status = this.getStatus(orderDetails.data.status)
                                    order.total = orderDetails.data.totalSellCharge

                                    orderItems.data.forEach(item => {
                                        let product = new Product()
                                        product.id = item.id
                                        product.name = item.sku.product.name
                                        product.quantity = item.quantity
                                        product.price = item.sellPrice
                                        product.total = item.total
                                        order.items.push(product)
                                    })
                                    return order;
                                })
                            );
                        })
                        return Promise.all(orderPromises)
                    },
                    (error) => {
                        this.errorText = error.response.data
                        this.errorDialog = true
                    }).then((orders) => {
                        this.orders = orders.sort(function(a, b) {
                            return b.status.localeCompare(a.status);
                        });
                        this.$store.dispatch("setExecuting", false)
                })
            },
            getStatus(orderStatus) {
                switch (orderStatus) {
                case "DRAFT":
                case "SUBMITTED":
                case "CONFIRMED":
                case "INVOICED":
                case "PAID":
                    return "Open"
                case "FULFILLED":
                    return "Fulfilled"
                default:
                    return "N/A"
                }
            },
            formatCurrency(n) {
                if(n)
                    return "$" + n.toFixed(2)
            },
            formatDateTime(date) {
                return moment(date).format("MM/DD/YYYY hh:mm a")
            },
        }
    }
</script>
<style scoped>
.v-chip.Open{
  background: #ffaa2c;
}
.v-chip.Fulfilled{
  background: #6dad70;
}
</style>